import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {ColorConfig, ColorConfigJson} from './color-config';

export type BorderConfigJson =  {
  width: number;
  color: ColorConfigJson;
  radius?: number;
};

export class BorderConfig implements JsonConfigInterface<BorderConfigJson> {

  public readonly color: ColorConfig = new ColorConfig();

  private _width: number = 0;
  private _radius: number = 0;

  constructor(json?: BorderConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get width(): number {
    return this._width;
  }

  public get radius(): number {
    return this._radius;
  }

  public deserializeJson(json: BorderConfigJson): void {
    this._width = json.width;
    this.color.deserializeJson(json.color);
    this._radius = Utils.valueOr(json.radius, 0);
  }
}
